<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <form>
          <div class="my-5"></div>
          <div class="row">
            <div class="col-sm-4 offset-sm-1"	>
              <div class="form-group" :class="{ 'form-group--error': $v.item.name.$error }">
                <label for="aspirantName">Nombre/s</label>
                <input
                  type="text"
                  class="form-control"
                  id="aspirantName"
                  aria-describedby="emailHelp"
                  v-model="item.name"
                />
                  <div class="error" v-if="!$v.item.name.required">Campo requerido</div>
                  <div class="error" v-if="!$v.item.name.letters">El nombre no debe contener números.</div>
                  <!-- <div class="has-error" v-if="!$v.item.name.minLength">El nombre debe tener al menos {{$v.item.name.$params.minLength.min}} caracteres.</div> -->
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group" :class="{ 'form-group--error': $v.item.lastName.$error }">
                <label for="aspirantLastName">Apellido/s</label>
                <input
                  type="text"
                  class="form-control"
                  id="aspirantLastName"
                  aria-describedby="emailHelp"
                  v-model="item.lastName"
                />
                  <div class="error" v-if="!$v.item.lastName.required">Campo requerido</div>
                  <div class="error" v-if="!$v.item.lastName.letters">El apellido no debe contener números.</div>
              </div>
            </div>

            <div class="col-sm-3">
              <div class="form-group" :class="{ 'form-group--error': $v.item.birthDate.$error }">
                <label for="aspirantBirthday">Fecha de nacimiento</label>
                <div class="row">
                  <div class="col-md-12">
                    <date-picker v-model="item.birthDate" :config="options"></date-picker>
                  </div>
                </div>
                  <div class="error" v-if="!$v.item.birthDate.required">Campo requerido</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.documentNumber.$error }">
                <label for="aspirantDni">DNI</label>
                <input
                  type="text"
                  class="form-control"
                  id="aspirantDni"
                  aria-describedby="emailHelp"
                  v-model="item.documentNumber"
                />
                  <div class="error" v-if="!$v.item.documentNumber.required">Campo requerido</div>
                  <div class="error" v-if="!$v.item.documentNumber.dni">El campo no debe contener caracteres especiales</div>
                  <div class="error" v-if="!$v.item.documentNumber.minLength || !$v.item.documentNumber.maxLength ">Debe ingresar un DNI válido</div>

              </div>
            </div>
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.cuilNumber.$error }">
                <label for="aspirantCuil">CUIL</label>
                <input
                  type="text"
                  class="form-control"
                  id="aspirantCuil"
                  aria-describedby="emailHelp"
                  v-model="item.cuilNumber"
                />
                  <div class="error" v-if="!$v.item.cuilNumber.required">Campo requerido</div>
                  <div class="error" v-if="!$v.item.cuilNumber.dni">Debe ingresar el CUIL sin guiones</div>
                  <div class="error" v-if="!$v.item.cuilNumber.minLength || !$v.item.cuilNumber.maxLength ">Debe ingresar un CUIL válido</div>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group" :class="{ 'form-group--error': $v.item.lastName.$error }">
                  <div class="fg-line">
                      <label>Género:</label>
                      <div class="select">
                          <select v-model="item.genderSelected" id="genderCode" name="genderSelected" class="form-control"><!-- v-validate="'required'" -->
                              <option value="">[Seleccione una opción]</option>
                              <option v-for="gender of genders" :key="gender.code" :value="gender">{{ gender.name}}</option>
                          </select>
                      </div>
                  </div>
                  <div class="error" v-if="!$v.item.genderSelected.required">Seleccione una opción</div>
                  <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1">
            <div class="form-group" :class="{ 'form-group--error': $v.item.nationalitySelected.$error }">
                <div class="fg-line">
                    <label>Nacionalidad:</label>
                    <div class="select">
                        <select v-model="item.nationalitySelected" id="countryCode" name="countrySelected" class="form-control"> <!-- v-validate="'required'" -->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="citizenship of countries" :key="citizenship.code_iso_alfa3" :value="citizenship">{{ citizenship.citizenship }}</option>
                        </select>
                    </div>
                </div>
                <div class="error" v-if="!$v.item.nationalitySelected.required">Campo requerido</div>
                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>
            <div class="col-sm-3 offset-sm-1">
            <div class="form-group" :class="{ 'form-group--error': $v.item.countrySelected.$error }">
                <div class="fg-line">
                    <label>País de Nacimiento:</label>
                    <div class="select">
                        <select v-model="item.countrySelected" @change="getProvinces(item.countrySelected)" id="countryCode" name="countrySelected" class="form-control"><!-- v-validate="'required'" -->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="country of countries" :key="country.code_iso_alfa3" :value="country">{{ country.common_name}}</option>
                        </select>
                    </div>
                </div>
                <div class="error" v-if="!$v.item.countrySelected.required">Campo requerido</div>
                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>
            <div class="col-sm-3">
            <div class="form-group" :class="{ 'form-group--error': $v.item.provinceSelected.$error }">
                <div class="fg-line">
                    <label>Provincia de Nacimiento:</label>
                    <div class="select">
                        <select v-model="item.provinceSelected" id="ProvinceCode" name="provinceSelected" class="form-control"> <!-- v-validate="'required'" -->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="province of provinces" :key="province.code_iso" :value="province">{{ province.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="error" v-if="!$v.item.provinceSelected.required">Campo requerido</div>
                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.townOfBirth.$error }">
                <label for="aspirantTownOfBirth">Ciudad de Nacimiento</label>
                <input
                  type="text"
                  class="form-control"
                  id="aspirantTownOfBirth"
                  aria-describedby="emailHelp"
                  v-model="item.townOfBirth"
                />
                  <div class="error" v-if="!$v.item.townOfBirth.required">Campo requerido</div>
              </div>
            </div>
            <div class="col-sm-3 offset-sm-1">
            <div class="form-group" :class="{ 'form-group--error': $v.item.bloodGroupSelected.$error }">
                <div class="fg-line">
                    <label>Grupo Sanguíneo:</label>
                    <div class="select">
                        <select v-model="item.bloodGroupSelected" id="bloodGrupCode" name="bloodGroupSelected" class="form-control"><!-- v-validate="'required'" -->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="bloodG of bloodGroups" :key="bloodG.code" :value="bloodG">{{ bloodG.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="error" v-if="!$v.item.bloodGroupSelected.required">Campo requerido</div>
                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>

            <div class="col-sm-3">
              <div class="form-group" :class="{ 'form-group--error': $v.item.bloodFactorSelected.$error }">
                  <div class="fg-line">
                      <label>Factor Sanguíneo:</label>
                      <div class="select">
                          <select v-model="item.bloodFactorSelected" id="bloodFactorCode" name="bloodFactorSelected" class="form-control"><!-- v-validate="'required'" -->
                              <option value="">[Seleccione una opción]</option>
                              <option v-for="bloodF of bloodFactors" :key="bloodF.code" :value="bloodF">{{ bloodF.name}}</option>
                          </select>
                      </div>
                  </div>
                  <div class="error" v-if="!$v.item.bloodFactorSelected.required">Campo requerido</div>
                  <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
              </div>
            </div>
            <div class="col-sm-3">
              <br>
              <br>
            </div>


          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTPFront } from '../../share';
import { validationMixin } from 'vuelidate'
import { required, minLength,maxLength } from 'vuelidate/lib/validators'
import {letters,dni} from '../../utils/validations'
import { mapGetters } from "vuex";
//const alpha = helpers.regex('alpha', /^[b-zA-Z]*$/);

export default {
  props: ["clickedNext", "currentStep"],
  mixins: [validationMixin],
  data() {
    return {
      item: {
        name: '',
        lastName: '',
        documentNumber: '',
        cuilNumber: '',
        birthDate: new Date(),
        nationalitySelected:'',
        countrySelected: '',
        provinceSelected: '',
        townOfBirth: '',
        bloodGroupSelected: '',
        bloodFactorSelected:'',
        genderSelected:''
      },
      citizenships: null,
      countries:null,
      provinces:null,
      bloodGroups:null,
      bloodFactors:null,
      genders:null,
      options: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        locale:"es",
        widgetPositioning: {
          vertical : "bottom",
          horizontal : "left"
        },
      },
    };
  },
  validations: {
    item: {
      name: {
        required,
        letters
      },
      lastName: {
        required,
        letters
      },
      genderSelected:{
        required
      },
      documentNumber:{
        required,
        dni,
        minLength : minLength(7),
        maxLength : maxLength(15)
      },
      cuilNumber:{
        required,
        dni,
        minLength : minLength(11),
        maxLength : maxLength(15)
      },
      birthDate:{
        required
      },
      nationalitySelected:{
        required
      },
      countrySelected:{
        required
      },
      provinceSelected:{
        required
      },
      townOfBirth:{
        required
      },
      bloodGroupSelected:{
        required
      },
      bloodFactorSelected:{
        required
      }
    }
  },
  created() {
    this.getCountries();
    this.getBloodGroups();
    this.getBloodFactors();
    this.getGenders();
  },
  computed:{
    ...mapGetters(["getLevel"]),
  },
  watch: {
    $v: {
      handler: function (val) {
        if (!val.$invalid) {
          // Formulario válido
          this.$store.commit('setStepOneData', this.item)
          this.$emit("can-continue", { value: true });
        } else {
          this.$emit("can-continue", { value: false });
        }
      },
      deep: true,
    },
    clickedNext(val) {
      if (val === true) {
        this.$v.item.$touch();
      }
    },
    currentStep(){
      if(!this.$v.$invalid){
        this.$emit("can-continue", { value: true });
      }
    }
  },
  mounted() {
    if (!this.$v.$invalid) {
      this.$store.commit('setStepTwoData', this.item)
      this.$emit("can-continue", { value: true });
    } else {
      this.$emit("can-continue", { value: false });
    }
  },
  methods: {
    getCountries() {
      HTTPFront.get('/getCountries')
      .then(res => {
        this.countries = res.data;
        this.$store.commit('setCountries', this.countries)
      })
    },
    getProvinces(countrySelected){
      HTTPFront.get('/getProvincesByCountry/'+ countrySelected.code_iso_alfa3)
      .then(res => {
        this.provinces = res.data;
      })
    },
    getBloodGroups() {
      HTTPFront.get('/getBloodGroups')
      .then(res => {
        this.bloodGroups = res.data;
      })
    },
    getBloodFactors() {
      HTTPFront.get('/getBloodFactors')
      .then(res => {
        this.bloodFactors = res.data;
      })
    },
    getGenders() {
      HTTPFront.get('/getGenders/'+this.getLevel)
      .then(res => {
        this.genders = res.data;
      })
    }
  }
};
</script>
<style>
.error{
  color:red;
}
</style>